import React  from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';

const twoThreeRows = (props) => {
  return (
    <div>
      <div className="wrapper">
        <Breadcrumbs/>
        {props.mainPanel}
        <div className={props.rows === 2 ? "two-three-rows__row two-rows" : "two-three-rows__row three-rows"} >
          <div className="two-three-rows__column">
            {props.contentPanel1}
          </div>
          <div className="two-three-rows__column">
            {props.contentPanel2}
          </div>
          
          {props.rows === 3 ? (
          <div className="two-three-rows__column">
            {props.contentPanel3}
          </div>
          ) : ('')}
          
        </div>
      </div>
      {props.footerPanel ? props.footerPanel : null}
    </div>
  )
}

export default twoThreeRows;


// WEBPACK FOOTER //
// ./src/layouts/TwoThreeRows/TwoThreeRows.js